import { render, staticRenderFns } from "./BsDatePickerDays.vue?vue&type=template&id=10a5a88c&scoped=true&"
import script from "./BsDatePickerDays.vue?vue&type=script&lang=js&"
export * from "./BsDatePickerDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5a88c",
  null
  
)

export default component.exports